<template>

    <div class="question__body" :class="{ '-locked': disabled }">
        <question-title :title="title" :sub-title="subTitle" :hashelp="hashelp" :uuid="uuid" :question-index="questionIndex"></question-title>
        <self-disablable v-if="selfDisablable" :label="selfDisablable" :answer="answer.answer"></self-disablable>

        <div class="matrix-h-scroll" :class="{ '-large': cols.length > 5 }">
            <div class="matrix-h-scroll--inner">
                <table class="matrix-2d matrix-table--h-scroll" :class="tableClass">
                    <colgroup>
                        <col class="premiere-colonne matrix-w-320">
                        <col class="autres-colonnes matrix-w-120" :span="cols.length">
                    </colgroup>
                    <thead>
                        <matrix-column-group :column-group="columnGroup" :span="cols.length"></matrix-column-group>
                        <tr>
                            <th class="matrix__header-title matrix-2d__header-title premiere-colonne">
                                <span v-html="headerTitle" class="premiere-colonne--fixed"></span>
                                <span v-html="headerTitle" class="premiere-colonne--runin"></span>
                            </th>
                            <th class="autres-colonnes" v-for="(column, index) of cols" :key="index" :class="{ 'col-locked': isColumnDisabled(column.value) }">
                                <span v-html="column.name"></span>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="!disabled">
                        <matrix-checkbox-col-sourced-row v-for="(choice, index) of choices" :key="index"
                            :question-index="questionIndex"
                            :choice="choice"
                            :row="choice.row"
                            :columns="cols"
                            :uukey="uukey"
                            :triggers="triggers"
                            :answer="answer.answer"
                            :disabled="disabled"
                            :disabled-columns="disabledColumns"
                            :read-only="readOnly"
                        ></matrix-checkbox-col-sourced-row>
                    </tbody>

                </table>
            </div>
        </div>

        <question-tip :questionTip="questionTip"></question-tip>
    </div>

</template>


<script>
import { isObject, map, forEach, find, differenceBy } from 'lodash';
import { questionMixin } from './mixins/question-mixin';
import { matrixMixin } from './mixins/matrix-mixin';
import { matrixColumnsMixin } from './mixins/matrix-columns-mixin';
import { matrixColSourcedMixin } from './mixins/matrix-col-sourced-mixin';

export default {
    name: 'matrix-checkbox-col-sourced',

    mixins:[
        questionMixin,
        matrixMixin,
        matrixColumnsMixin,
        matrixColSourcedMixin,
    ],

    methods: {
        changeColumnValue(col, state, rowID)
        {
            this.$store.dispatch('CHANGE_ANSWER', [this.uukey, state, rowID, col]);
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-checkbox-col-sourced.vue